import * as common from './common';
import * as zApiInstances from './zApiInstances';

export default {
  /** common - Functions that don't need permissions */
  common,
  zApiInstances,
};
